import React, { FC, useMemo } from 'react';
import { ICustomsForm } from '../../interfaces/umbracoNodes/contentSlices';
import { Column, Columns, Container } from '../base/grid';
import { H1 } from '../base/typography';
import SendReceiptMultiStep from '../sendReceiptMultistep';
import { TranslationsContext } from '../sendReceiptMultistep/context/translationsContext';

interface Props {
	content: ICustomsForm;
}

export const CustomsForm: FC<Props> = ({ content }: Props) => {
	const parsedTranslations: TranslationsContext | undefined = useMemo(() => {
		let parsedTranslations;
		try {
			parsedTranslations = JSON.parse(content.Values.Translations.replace('<p>', '').replace('</p>', ''));
		} catch (error) {
			console.error('Failed to parse translations for CustomsForm', error);
		}
		return parsedTranslations;
	}, [content.Values.Translations]);

	return (
		<Container>
			{content.Values.Title && (
				<H1 marginTop="8rem" marginBottom="4rem">
					{content.Values.Title}
				</H1>
			)}
			<Columns>
				<Column desktopSmall={2 / 3}>
					<SendReceiptMultiStep translations={parsedTranslations} />
				</Column>
			</Columns>
		</Container>
	);
};
